import { Task } from '../lib/types/database.types'

const normalizeMap = (value: Task['status_due_dates'] | Task['status_completed_dates']) => {
  if (!value || typeof value !== 'object') {
    return {}
  }

  return value
}

export const getTaskStatusDueDate = (task: Task, status: string) => {
  const map = normalizeMap(task.status_due_dates)
  return typeof map[status] === 'string' ? map[status] : null
}

export const getTaskCurrentStatusDueDate = (task: Task) =>
  getTaskStatusDueDate(task, task.status) || task.projected_completion || null

export const getTaskStatusCompletedAt = (task: Task, status: string) => {
  const map = normalizeMap(task.status_completed_dates)
  return typeof map[status] === 'string' ? map[status] : null
}

const parseDateOnly = (value: string) => {
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, (month || 1) - 1, day || 1)
}

const getTodayDateOnly = () => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), now.getDate())
}

export const isTaskStatusOverdue = (task: Task) => {
  const currentDueDate = getTaskCurrentStatusDueDate(task)
  if (!currentDueDate || task.status === 'completed') {
    return false
  }

  return parseDateOnly(currentDueDate) < getTodayDateOnly()
}

export const isTaskOverallDueOverdue = (task: Task) => {
  if (!task.overall_due_date || task.status === 'completed') {
    return false
  }

  return parseDateOnly(task.overall_due_date) < getTodayDateOnly()
}
